import { render } from "./Home.vue?vue&type=template&id=db2d7bf8&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=db2d7bf8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-db2d7bf8"

export default script